const baseUrl = "https://www.omnseotools.ch";

export const getCanonicalUrl = (path: string): string => {
  // Handle root path
  if (path === '/') return baseUrl;
  
  // Clean the path and ensure it starts with a slash
  const cleanedPath = cleanPath(path);
  
  // Log for debugging
  console.log('Generating canonical URL for path:', path);
  console.log('Cleaned path:', cleanedPath);
  
  return `${baseUrl}${cleanedPath}`;
};

export const isValidPath = (path: string): boolean => {
  const validPaths = [
    '/',
    '/keyword-analyse',
    '/backlink-profil',
    '/content-optimierung',
    '/serp-snippet',
    '/link-optimierer',
    '/lokale-seo',
    '/performance-check',
    '/mobile-seo',
    '/knowledge',
    '/about',
    '/contact',
    '/privacy',
    '/terms',
    '/404'
  ];
  
  // Clean the path before checking
  const cleanedPath = cleanPath(path);
  
  // Special handling for knowledge routes
  if (cleanedPath.startsWith('/knowledge/')) return true;
  
  // Log for debugging
  console.log('Validating path:', cleanedPath);
  console.log('Is valid:', validPaths.includes(cleanedPath));
  
  return validPaths.includes(cleanedPath);
};

export const cleanPath = (path: string): string => {
  // Handle root path
  if (!path || path === '/') return '/';
  
  // Remove any query parameters, hash fragments, and trailing slashes
  const pathWithoutQuery = path.split(/[?#]/)[0].replace(/\/+$/, '');
  
  // Split path into segments, remove empty ones and duplicates
  const segments = Array.from(new Set(pathWithoutQuery.split('/').filter(Boolean)));
  
  // Log for debugging
  console.log('Original path:', path);
  console.log('Cleaned segments:', segments);
  
  // Reconstruct path with leading slash
  return '/' + segments.join('/');
};